import React, { useState, useEffect, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha } from "@mui/material";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Delete } from '../../../../../assets/images/trash.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg'
import MessageTabForm from "../Forms/MessageTabForm";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import { getMessageByPatientIdRequest } from "src/modules/app/store/appActions";
import dayjs from "dayjs";
import DeleteDialog from "../../DeleteDialog";
import useResponsive from "src/components/hooks/useResponsive";
import useAppointmentDetails from "../../UseAppointmentDetails";
import { AllTabsMainContainer, StatusHeader } from "../Style";
import MessageCard from "../CardView/MessageCard";



const columns = [
  { id: "message", label: "Message", sx: { width: "838px", minWidth: "150px", textAlign: 'left' } },
  { id: "language", label: "Language", sx: { "& .css-axw7ok": { justifyContent: 'center' } }, },
  { id: "addedDate", label: "Added Date", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
  // { id: "addedBy", label: "Added By", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
];



const Message = ({ shouldRefresh }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const [openWhatsappDialog, setOpenWhatsappDialog] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [message, setMessages] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteMessageId, setDeleteMessageId] = useState(null);
  const { PatientId } = useAppointmentDetails();


  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const handleOpenDeleteDialog = (messageId) => {
    setDeleteMessageId(messageId);
    setOpenDeleteDialog(true);
  };
  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);

  const formatDate = (timestamp) => {
    return dayjs(timestamp).format("D MMM, h:mmA");
  };

  const fetchMessages = useCallback(
    (page = 0, perPage = 10) => {
      const fetchData = async () => {
        const params = {
          page: page + 1,
          limit: perPage,
        };

        const response = await new Promise((resolve, reject) => {
          dispatch(getMessageByPatientIdRequest({ patientId: PatientId, params }, resolve, reject));
        });

        if (response?.data && response?.meta) {
          setMessages(response.data);
          setTotalCount(response.meta.totalRecords);

        } else {
          console.log('Error fetching Payments');
        }

      }
      fetchData();

    },
    [dispatch, PatientId],
  );
  useEffect(() => {
    if (PatientId) {
      fetchMessages(page, perPage);
    }
  }, [PatientId, fetchMessages, page, perPage, shouldRefresh]);

  const data = message.map((messageData) => ({
    messageId: messageData?.id,
    message: messageData?.message,
    language: messageData?.language,
    addedDate: dayjs(messageData.createdAt).format("DD-MM-YYYY"),
    //   addedBy: 'John Doe',
  }));
  const actions = [
    // { label: "Edit", icon: <Edit />, onClick: (row) => alert(`Viewing ${row.patient}`) },
    { label: "Delete", icon: <Delete />, onClick: (row) => handleOpenDeleteDialog(row.messageId) },
  ];
  return (
    <>
      <AllTabsMainContainer>
        {(isMobile || isTablet) ?
          <MessageCard
            message={message}
            page={page}
            perPage={perPage}
            setPage={setPage}
            totalCount={totalCount}
            fetchMessages={fetchMessages}
            setOpenWhatsappDialog={setOpenWhatsappDialog}
            setWhatsappMessage={setWhatsappMessage}
            setPhoneNumber={setPhoneNumber}
          /> :
          <CustomTable
            key={page}
            columns={columns}
            data={data}
            disabled={true}
            actions={actions}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            noDataComponent={
              <NoDataFound
                title="No Messages Found!"
                showButton={false}
                description="No communication logs found for this patient."
              />
            }
          />
        }
      </AllTabsMainContainer>
      <DialogBox open={openWhatsappDialog} onClose={() => setOpenWhatsappDialog(false)} sx={{ margin: '10px !important' }}>
        <Box p={2} textAlign="center">
          <StatusHeader>Would you like to share this message on WhatsApp?</StatusHeader>
          <Box mt={2} display="flex" justifyContent="flex-end">
            <ButtonComponent onClick={() => setOpenWhatsappDialog(false)}>No</ButtonComponent>
            <ButtonComponent
              variant="contained"
              onClick={() => {
                const message = encodeURIComponent(whatsappMessage || "Hello from Clinic");
                const url = `https://wa.me/${phoneNumber}?text=${message}`;
                window.open(url, '_blank');
                setOpenWhatsappDialog(false);
              }}
            >
              Yes, Share
            </ButtonComponent>
          </Box>
        </Box>
      </DialogBox>

    </>
  )
};

export default Message;

